import React from 'react';

const Camera = () => (
  <svg
    width="24px"
    height="17px"
    viewBox="0 0 24 17"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xlink="http://www.w3.org/1999/xlink"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-39.000000, -702.000000)" stroke="#285AFF">
        <g transform="translate(40.000000, 703.000000)">
          <path d="M6.0664,0 L11.1336,0 L12.8,3 L15.4,3 C16.6150264,3 17.6,3.98497355 17.6,5.2 L17.6,12.6 C17.6,13.8150264 16.6150264,14.8 15.4,14.8 L2.2,14.8 C0.98497355,14.8 -2.95291385e-16,13.8150264 0,12.6 L0,5.2 C-5.92887035e-16,3.98497355 0.98497355,3 2.2,3 L4.4,3 L6.0664,0 Z" />
          <circle cx="8.8" cy="8.8" r="4.8" />
          <circle cx="8.8" cy="8.8" r="2.8" />
          <g transform="translate(12.000000, 0.000000)">
            <circle fill="#FFFFFF" cx="5.4" cy="5.4" r="4.9" />
            <g transform="translate(3.456000, 3.456000)" strokeLinecap="round">
              <line x1="2.052" y1="1.42386103e-17" x2="2.052" y2="4.104" />
              <line x1="4.104" y1="2.052" x2="0" y2="2.052" />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default Camera;
